import React, { useContext, useEffect, useState } from 'react';
import { SessionContext } from '../contexts/session-context';
import { HelpPreference } from '@models/help-preference.model';
import HelpPreferenceService from '@services/help-preference.service';
import {
  HelpPreferenceContext,
  HelpPreferenceContextType,
} from '@contexts/help-preference-context';

export default function HelpPreferenceContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [helpPreference, setHelpPreference] = useState<
    HelpPreference | undefined
  >(undefined);
  const sessionContext = useContext(SessionContext);
  const user = sessionContext?.session?.user;
  useEffect(() => {
    HelpPreferenceService.show(user.id).then((res) => {
      if (res instanceof HelpPreference) {
        setHelpPreference(res);
      }
    });
  }, []);

  const setOrUpdatePreference = (
    helpPreference: HelpPreference,
    callback: VoidFunction,
  ) => {
    HelpPreferenceService.save(helpPreference).then((res) => {
      if (res instanceof HelpPreference) {
        setHelpPreference(res);
      }
      callback();
    });
  };

  return (
    <>
      {helpPreference && (
        <HelpPreferenceContext.Provider
          value={
            {
              helpPreference,
              setOrUpdatePreference,
            } as HelpPreferenceContextType
          }>
          {children}
        </HelpPreferenceContext.Provider>
      )}
    </>
  );
}
